<template>
  <div class="n2-pagina" ref="raiz">
    <N2CabezaPagina :titulo="titulo" :subtitulo="P.Subtitulo?.Texto" :imagen="P.Imagen" :filtro="P.ImagenFiltro"
      :boton="P.ShowButton ? P.Button : null" />

    <section class="n2-seccion n2-seccion--pagina">
      <!-- Una columna (lo habitual): cada notario en una fila con foto y texto; con más columnas, en tarjetas -->
      <div class="n2-contenedor" :class="columnas === 1 ? 'n2-perfiles' : 'n2-lista n2-lista--personas'" :style="{ '--n2-columnas': columnas }">
        <article v-for="(n, i) in notarios" :key="n.id ?? i" class="n2-perfil n2-aparece"
          :class="{ 'n2-perfil--invertido': columnas === 1 && n.ImageLeft === false, 'n2-perfil--sin-foto': !n.Imagen }">
          <figure v-if="n.Imagen" class="n2-perfil__foto">
            <img :src="imagenIDtoSRC(n.Imagen)" :alt="'Fotografía de ' + n.Nombre" loading="lazy" />
          </figure>
          <div class="n2-perfil__texto">
            <span class="n2-perfil__num" aria-hidden="true">{{ String(i + 1).padStart(2, '0') }}</span>
            <h2 class="n2-perfil__nombre">{{ n.Nombre }}</h2>
            <div v-if="n.Descripcion" class="n2-texto-rico" v-html="conSaltos(n.Descripcion)"></div>
            <div v-if="n.Email || n.Web" class="n2-perfil__enlaces">
              <a v-if="n.Email" :href="'mailto:' + n.Email" class="n2-boton n2-boton--linea">
                <v-icon size="18">mdi-email-outline</v-icon> {{ $t('contactar') }}
              </a>
              <a v-if="n.Web" :href="urlExterna(n.Web)" target="_blank" rel="noopener" class="n2-boton n2-boton--linea">
                <v-icon size="18">mdi-web</v-icon> {{ $t('webPersonal') }}
              </a>
            </div>
          </div>
        </article>
      </div>
    </section>

    <SolicitudAccesoPagina origen="notarios" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { tituloSeccion, conSaltos, urlExterna, columnasPanel, useAparicion } from '../../composables/useNotaria2'
import N2CabezaPagina from './N2CabezaPagina.vue'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t } = useUtils()
const raiz = ref(null)
useAparicion(raiz)

// Panel: Diseño páginas → Notarios (cabecera y columnas) y los notarios de Datos generales
const P = computed(() => NOTARIA.value?.Theme?.Notarios ?? {})
const titulo = computed(() => P.value.Titulo?.Texto || tituloSeccion(NOTARIA.value, 'Notario', $t))
const notarios = computed(() => NOTARIA.value?.Notarios ?? [])
// Con un solo notario, siempre en fila (una tarjeta estrecha quedaría perdida en la página)
const columnas = computed(() => notarios.value.length === 1 ? 1 : columnasPanel(P.value.NumeroColumnas, 1))
</script>
